class LoadButtonComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('project-loaded', (event) => this.onUpdate(event.detail.load), true)
    document.addEventListener('load-model-update', async (event) => this.onUpdate(event.detail.load), true)
  }

  onUpdate(loadModel) {
    let str = '<strong>Loads</strong>'
    str += `<div>Tension = ${loadModel.tensileLoad} kips</div>`
    str += `<div>Shear X = ${loadModel.shearXLoad} kips</div>`
    str += `<div>Shear Y = ${loadModel.shearYLoad} kips</div>`
    document.getElementById('load-button').innerHTML = str
  }

  connectedCallback() {
    this.innerHTML = String.raw`
      <div class="card">
        <a href="#" data-bs-toggle="modal" data-bs-target="#modal-load-dialog" style="text-decoration: none;">
          <div class="card panel-shadow text-center" style="padding:10px;" id="load-button">
            <strong>Loads</strong>
            <div>Tension = 2.00 kips</div>
            <div>Shear X = 2.00 kips</div>
            <div>Shear Y = 2.00 kips</div>
          </div>
        </a>
      </div>
    `
  }
}

customElements.define('load-button-component', LoadButtonComponent);